class CardCarousel extends HTMLElement {
  constructor() {
    super();

    this.itemsNode = this.querySelector('[data-ref="items"]');
    this.prevButtonNode = this.querySelector('[data-ref="prev"]');
    this.nextButtonNode = this.querySelector('[data-ref="next"]');

    this.currentIndex = 0;

    this._updateButtonStates();

    this.prevButtonNode.addEventListener('click', () => {
      this._scrollToIndex(this.currentIndex - 1);
    });
    this.nextButtonNode.addEventListener('click', () => {
      this._scrollToIndex(this.currentIndex + 1);
    });

    this.itemsNode.addEventListener('scroll', () => {
      window.requestAnimationFrame(() => {
        const total = this.itemsNode.children.length;
        for (let i = 0; i < total; i++) {
          const child = this.itemsNode.children[i];
          if (child.offsetLeft >= this.itemsNode.scrollLeft) {
            this.currentIndex = i;
            this._updateButtonStates();
            break;
          }
        }
      });
    });
  }

  _updateButtonStates() {
    this.prevButtonNode.disabled = this.currentIndex <= 0;
    this.nextButtonNode.disabled = this.currentIndex >= this.itemsNode.children.length - 1;
  }

  _scrollToIndex(index) {
    if (index < 0 || index >= this.itemsNode.children.length) {
      return;
    }
    this.itemsNode.children[index].scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
    this.currentIndex = index;
    this._updateButtonStates();
  }
}

window.customElements.define('cla-cardcarousel', CardCarousel);
